import { Send, Twitter } from "lucide-react";
import { Logo } from "./Logo";
import { TG_URL, X_URL } from "@/lib/site";

export const Footer = () => (
    <footer data-testid="footer" className="relative z-10 border-t border-orange-500/15 bg-[#0D0B14] py-16">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 px-5 text-center">
            <div className="flex items-center gap-3">
                <Logo size={44} />
                <div className="text-left">
                    <p className="font-heading text-sm font-extrabold tracking-widest text-orange-400">PUPOWEENWIFHAT</p>
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-slate-500">Small dog · Big dreams</p>
                </div>
            </div>
            <div className="flex gap-4">
                <a
                    href={X_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-x-link"
                    aria-label="Follow on X"
                    className="flex h-11 w-11 items-center justify-center rounded-full border border-slate-600/50 text-slate-300 transition-[border-color,color,box-shadow] duration-300 hover:border-orange-400 hover:text-orange-400 hover:shadow-[0_0_20px_rgba(255,107,0,0.35)]"
                >
                    <Twitter size={18} />
                </a>
                <a
                    href={TG_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-telegram-link"
                    aria-label="Join Telegram"
                    className="flex h-11 w-11 items-center justify-center rounded-full border border-slate-600/50 text-slate-300 transition-[border-color,color,box-shadow] duration-300 hover:border-emerald-400 hover:text-emerald-400 hover:shadow-[0_0_20px_rgba(0,255,135,0.35)]"
                >
                    <Send size={18} />
                </a>
            </div>
            <p className="max-w-xl text-xs leading-relaxed text-slate-500">
                $POWEEN is a memecoin created for entertainment and community. Nothing on this
                site is financial advice. Crypto is spooky — never invest more than you can
                afford to lose. The hat stays on. © 2026 Pupoweenwifhat.
            </p>
        </div>
    </footer>
);
